import React, { useState } from 'react';
import { App, Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { getBudgetByIdApi } from 'api/budget';
import { getAccessTokenApi } from 'api/auth';
import { selectBudgetDownloadComponent } from './selectBudgetDownload';

function DownloadBudgetButton({ idBudget, size = 'middle' }) {
  const { notification } = App.useApp();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!idBudget) return;
    setLoading(true);
    try {
      const token = getAccessTokenApi();
      const res = await getBudgetByIdApi(token, idBudget);
      // El endpoint legacy devuelve { state, message, data } donde data es el
      // row del view budget_client (cliente+presupuesto flat).
      const budget = res?.data;
      if (!budget?.idBudget || res?.state === 'error') {
        notification.error({
          message: 'No se pudo cargar el presupuesto',
          description: res?.message || undefined,
        });
        return;
      }
      const Cmp = selectBudgetDownloadComponent(budget.version);
      notification.open({
        message: `Descargar presupuesto #${budget.idBudget}`,
        btn: <Cmp budget={budget} />,
        duration: 0,
      });
    } catch (err) {
      notification.error({ message: err?.message || 'Error al cargar' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Descargar PDF">
      <Button size={size} icon={<DownloadOutlined />} loading={loading} onClick={handleClick} />
    </Tooltip>
  );
}

export default DownloadBudgetButton;
